import Vue from "vue";
import Vuex from "vuex";
import decode from "jwt-decode";
import router from "../router/index";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    enlaceToken: null,
    usuario: null,
    mensajeError: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setMensajeError(state, mensajeError) {
      state.mensajeError = mensajeError;
    },
    setEnlaceToken(state, enlaceToken) {
      state.enlaceToken = enlaceToken;
    },
  },
  actions: {
    guardarToken({ commit }, token) {
      commit("setToken", token);
      commit("setUsuario", decode(token));
      localStorage.setItem("token", token);
    },
    autoLogin({ commit }) {
      let token = localStorage.getItem("token");
      if (token) {
        commit("setToken", token);
        commit("setUsuario", decode(token));        
        router.push({ name: "Home" });
      }
    },
    salir({ commit }) {
      commit("setToken", null);
      commit("setUsuario", null);
      localStorage.removeItem("token");
      router.push({ name: "Login" });
    },
    errorMensaje({ commit }, error) {
      console.log(error);
      let mensajeError = "Upps algo salió mal :(";
      //console.log(error);
      if (error.status === 401 || error.status === 403) {
        //salir
        commit("setToken", null);
        commit("setUsuario", null);
        localStorage.removeItem("token");
        router.push({ name: "login", params: { salirApp: "exitApp" } });
      } else if (error.status === 500) {
        mensajeError =
          "Upps algo salió mal comuníquese con el área de soporte  :(";
      } else if (error.status === 400) {
        mensajeError = error.data.erros;
      } else {
        mensajeError = error.data;
      }
      return mensajeError;
    },
  },
  modules: {},
});
